module.exports = __webpack_public_path__ + "img/en.dfa63ec3.png";